module.exports = __webpack_public_path__ + "img/LBA-Shop.0f45a62a.svg";